




import Vue from 'vue';
import InformationList from '@/components/information/information-list.component.vue';

export default Vue.extend({
  components: {
    'information-list': InformationList,
  },
});
